import PropTypes from 'prop-types';

import {  countries } from '../../assets/nationalities';
import { useTranslation } from 'react-i18next';
const EmployerWork = ({ workId, methods, remove }) => {
    const { register, setValue, formState: { errors } } = methods;
const { t } = useTranslation();
    return (
        <div className="row my-4 background-light p-3 border rounded">
            
            <div className="row">
                <div className="col-lg-6 mb-3">
                    <label htmlFor={`employment[${workId}].employment_from`}>{t("Date From")}</label>
                    <input {...register(`employment[${workId}].employment_from`, { required: t("Start date is required") })} type="date" className="form-control" />
                    <p className="text-primary biodata">{errors.employment?.[workId]?.employment_from?.message}</p>
                </div>
                <div className="col-lg-6 mb-3">
                    <label htmlFor={`employment[${workId}].employment_to`}>{t("Date To")}</label>
                    <input {...register(`employment[${workId}].employment_to`, { required: t("End date is required") })} type="date" className="form-control" />
                    <p className="text-primary biodata">{errors.employment?.[workId]?.employment_to?.message}</p>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-4 mb-3">
                    <label htmlFor={`employment[${workId}].employment_country`}>{t("Country")}</label>


                    <select
                        className="form-select"
                        id="nationality"
                        {...register(`employment[${workId}].employment_country`, { required: t("Country is required") })}
                        onChange={(e) => setValue(`employment[${workId}].employment_country`, e.target.value || "")}

                    >
                        <option value="">{t("Country")}</option>
                        {countries.map((nation) => (
                            <option key={nation} value={nation}>
                                {nation}
                            </option>
                        ))}
                    </select>
                    <p className="text-primary biodata">{errors.employment?.[workId]?.employment_country?.message}</p>
                </div>
                <div className="col-lg-4 mb-3">
                    <label htmlFor={`employment[${workId}].employment_employer`}>{t("Employer")}</label>
                    <input {...register(`employment[${workId}].employment_employer`, { required: t("Employer name is required") })} type="text" className="form-control" />
                    <p className="text-primary biodata">{errors.employment?.[workId]?.employment_employer?.message}</p>
                </div>
                <div className="col-lg-4 mb-3">
                    <label htmlFor={`employment[${workId}].employment_duties`}>{t("Work Duties")}</label>
                    <input {...register(`employment[${workId}].employment_duties`, { required: t("Work duties are required") })} type="text" className="form-control" />
                    <p className="text-primary biodata">{errors.employment?.[workId]?.employment_duties?.message}</p>
                </div>
            </div>
            <div className="row">
            <div className="col-lg-4 mb-3">
                <button style={{ width: '100px' }} type="button" className="my-3 btn btn-danger ms-2" onClick={(e) => {
                    e.preventDefault();

                    remove(workId);

                }} > {t("Remove")}</button>
            </div></div>
        </div>
    );
};
EmployerWork.propTypes = {
    methods: PropTypes.shape({
        register: PropTypes.func.isRequired,
        setValue: PropTypes.func.isRequired,
        formState: PropTypes.shape({
            errors: PropTypes.object.isRequired
        }).isRequired
    }).isRequired,
     remove: PropTypes.func.isRequired,
    workId: PropTypes.number.isRequired

}
export default EmployerWork;    